module.exports = __webpack_public_path__ + "img/scott.ead5d305.jpg";